import { useState } from "react";
import { getDocumentById } from "../axios/document-axios";
import { toast } from "react-toastify";

const TOAST_IDS = {
    missingId: "document-missing-id",
    loadError: "document-load-error",
};

const BASE_TOAST_OPTIONS = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
};

const useDocument = () => {
    // Cache for documents
    const [documentCache, setDocumentCache] = useState({});
    const [currentDocument, setCurrentDocument] = useState({});

    const getDocument = async (documentId) => {
        if (documentCache[documentId]) {
            setCurrentDocument(documentCache[documentId])
            return documentCache[documentId];
        }
        // Call the getDocumentById API
        if (!documentId) {
            console.error("documentId is missing.");
            toast.error("Document ID is missing.", {
                ...BASE_TOAST_OPTIONS,
                toastId: TOAST_IDS.missingId,
            });
            return;
        }

        try {
            const response = await getDocumentById.post(
                `?document_id=${documentId}`,
                null,
                { headers: { "Content-Type": "application/json" } }
            );
            const newDocument = response.data.document;
            const filteredDocument = {
                line_info: newDocument.line_info,
                text: newDocument.text,
                translatedText: newDocument.translatedText,
                file_url: newDocument.file_url
            };
            setCurrentDocument(filteredDocument);
            setDocumentCache(documentCache => ({
                ...documentCache,
                [documentId]: filteredDocument
            }));
            return filteredDocument;
        } catch (error) {
            console.error("Error fetching document:", error);
            toast.error("Error loading page content.", {
                ...BASE_TOAST_OPTIONS,
                toastId: TOAST_IDS.loadError,
            });
        }
    };
    return { getDocument };
};

export default useDocument;
